// extracted by mini-css-extract-plugin
module.exports = {"frame":"JoinForm_frame__1QZgp","logo":"JoinForm_logo__23nph","escape":"JoinForm_escape__1nZCV"};